
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 3 2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#ce1126","d":"M0 0h1v2H0z"}}),_c('path',{attrs:{"fill":"#fcd116","d":"M1 0h1v2H1z"}}),_c('path',{attrs:{"fill":"#009460","d":"M2 0h1v2H2z"}})])
          )
        }
      }
    